import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSpeaker16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconSpeaker16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M4.765 6.112h.39l.287-.263 2.01-1.847v8.06l-2.01-1.847-.287-.264H3.5a.5.5 0 0 1-.5-.5V6.612a.5.5 0 0 1 .5-.5zM2 6.612a1.5 1.5 0 0 1 1.5-1.5h1.265l2.849-2.617a.5.5 0 0 1 .838.369V13.2a.5.5 0 0 1-.838.368l-2.849-2.617H3.5a1.5 1.5 0 0 1-1.5-1.5zm9.053-2.836a.5.5 0 0 1 .67-.223L11.5 4l.224-.447.002.001.003.002.01.004.107.061c.067.041.159.101.267.182.215.162.497.41.778.76C13.456 5.27 14 6.378 14 8c0 1.618-.53 2.725-1.082 3.433a4.3 4.3 0 0 1-.76.76 3 3 0 0 1-.368.244l-.008.005-.003.002h-.002l-.227-.44.226.44a.5.5 0 0 1-.459-.888l-.047-1.385a4 4 0 0 1-.418.484l-.013.012-.005.004-.001.001-.001.001-.333-.373.332.373a.5.5 0 0 1-.666-.745l-.034-3.89.034 3.89.003-.003.022-.021q.031-.03.092-.097c.078-.089.186-.222.293-.394C10.793 9.068 11 8.585 11 8s-.207-1.068-.424-1.413a3 3 0 0 0-.407-.512l-.003-.003-.034-.033-.005-.671a.5.5 0 0 1 .705-.042L10.5 5.7c.332-.374.333-.373.333-.373l.002.002.005.004.013.012.042.04a3 3 0 0 1 .221.244l-.047-1.375.047 1.375c.093.113.2.256.308.427C11.707 6.508 12 7.174 12 8s-.293 1.492-.576 1.944a4 4 0 0 1-.153.227l.047 1.385.007-.004.044-.025c.04-.026.103-.067.18-.127a3.3 3.3 0 0 0 .581-.583c.424-.542.87-1.435.87-2.817 0-1.379-.456-2.27-.89-2.813a3.3 3.3 0 0 0-.597-.584 2 2 0 0 0-.231-.153l-.008-.004a.5.5 0 0 1-.22-.67m-.927 1.592.006.67a.5.5 0 0 1-.005-.67"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconSpeaker16);
